import { Helmet } from "react-helmet-async";
import React from "react";
const SEO = ({ seoData, initialSeo }) => {
  const seo = seoData || initialSeo || {};

  if (!seo || Object.keys(seo).length === 0) return null;

  return (
    <Helmet>

      <title>{seo?.meta_title || ''}</title>
      <meta name="keywords" content={seo?.keywords || ''} />
      <meta name="description" content={seo?.description || ''} />
      <link rel="canonical" href={seo?.canonical_tag || ""} />
      {/* OG Tags */}
      <meta property="og:locale" content={seo?.og_locale || 'en_US'} />
      <meta property="og:type" content={seo?.og_type || ''} />
      <meta property="og:title" content={seo?.og_title || ''} />
      <meta property="og:description" content={seo?.og_description || ''} />
      <meta property="og:url" content={seo?.og_url || ""} />
      <meta property="og:site_name" content={seo?.og_site_name || ''} />
      {seo.og_image && <meta property="og:image" content={seo.og_image_url || ""} />}

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content={seo?.meta_twitter_card || ''} />
      <meta name="twitter:site" content={seo?.meta_twitter_site || '@default_site'} />
      <meta name="twitter:title" content={seo?.meta_twitter_title || 'Default Title'} />
      <meta name="twitter:description" content={seo?.meta_twitter_description || ''} />
      {seo.meta_twitter_image && <meta name="twitter:image" content={seo.meta_twitter_image || ""} />}


      {/* All Schema */}

      {seo.faq_schema && (
        <script type="application/ld+json">
          {(seo.faq_schema)}
        </script>
      )}

      {seo.article_schema && (
        <script type="application/ld+json">
          {(seo.article_schema)}
        </script>
      )}

      {seo.review_schema && (
        <script type="application/ld+json">
          {(seo.review_schema)}
        </script>
      )}
      
      {seo.organisation_schema && (
        <script type="application/ld+json">
          {(seo.organisation_schema)}
        </script>
      )}

    </Helmet>
  );
};

export default SEO;